export type Beds = {
    beds_min: string;
    beds_max: string;
    buttonTitle: string;
};

export const getBedsParams = (beds: Beds) => {
    const { beds_min, beds_max } = beds;

    const shouldAddBedsMin = beds_min !== '' && beds_min !== 'No min';
    const shouldAddBedsMax = beds_max !== '' && beds_max !== 'No max';

    const bedsMin = shouldAddBedsMin ? beds_min : '';
    const bedsMax = shouldAddBedsMax ? beds_max : '';

    return {
        beds_min: bedsMin,
        beds_max: bedsMax
    };
};
